import EntityDescription from 'src/store/entities/types/EntityDescription';

/**
 * Every Entity extends this BaseEntity
 * containing the following meta data.
 *
 * BaseEntity does nothing at the moment
 * It is mostly used as a marker type
 */
export default abstract class BaseEntity {
    readonly id: string;

    protected constructor(json: any) {
        this.id = json.id;
    }

    abstract toString(): string;

    abstract getEntityDescription(): EntityDescription;
}
